export type UmpireIncidentType =
  | 'second_half_started'
  | 'missed_penalty'
  | 'kick_off'
  | 'second_yellow_card'
  | 'penalty'
  | 'yellow_card'
  | 'assist'
  | 'red_card'
  | 'goal'
  | 'own_goal'
  | 'half_time'
  | 'match_ended'
  | 'match_started'
  | 'substitution'
  | 'component';
